var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awarded-page"},[_c('img',{staticClass:"awarded-image",attrs:{"src":require("../assets/img/获奖名单.jpg"),"alt":"获奖名单","height":"4776","width":"1920"}})])
}]

export { render, staticRenderFns }